import { StyleSheet } from '@react-pdf/renderer';

// Bari Design System - PDF Color Palette
const colors = {
  // Text
  textDark: '#000000',           // colorText-Dark, colorTextTer-Dark, colorTextQua-Dark, colorTextBase, colorTextSec-Dark
  textLight: '#FFFFFF',          // colorText-Light
  textBrandPrimary: '#0090FF',   // ColorTextBrandPrimary
  // Brand
  primaryMain: '#0090FF',        // colorPrimaryMain
  secondaryMain: '#101010',      // colorSecondaryMain
  // Backgrounds
  bgWhite: '#FFFFFF',
  bgLayoutPrimary: '#F5F6F9',    // colorBgLayoutPrimary
  bgLayoutSecondary: '#001F3F',  // colorBgLayoutSecondary
  bgBlack100: '#E7E7E7',        // Colors-Base-Black-100
  // Borders
  borderColor: '#D6DBE7',       // colorBorder
  borderBg: '#D5DBE7',          // colorBorderBg
};

export const avmPageStyles = StyleSheet.create({
  // Page
  page: {
    width: 595,
    height: 842,
    backgroundColor: colors.bgWhite,
    flexDirection: 'column',
    fontFamily: 'Helvetica',
  },
  pageContent: {
    flex: 1,
    padding: 16,
    flexDirection: 'column',
    gap: 16,
  },

  // Header bar
  headerBar: {
    paddingBottom: 8,
    borderBottom: `1 solid ${colors.borderColor}`,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    textAlign: 'right',
    color: colors.textDark,
    fontSize: 10,
    fontWeight: 'bold',
    lineHeight: 1.6,
  },
  headerSubtitle: {
    textAlign: 'right',
    color: colors.textDark,
    fontSize: 9,
    fontWeight: 'normal',
    lineHeight: 1.3,
  },

  // Section header (light bar with accent stripe)
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.bgLayoutPrimary,
    gap: 8,
    paddingRight: 8,
  },
  sectionHeaderAccent: {
    width: 3,
    height: 28,
    backgroundColor: colors.primaryMain,
  },
  sectionHeaderText: {
    color: colors.textDark,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: 1.3,
  },

  // Section header dark (for amostras)
  sectionHeaderDark: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.bgLayoutSecondary,
    gap: 8,
    paddingRight: 8,
  },
  sectionHeaderDarkText: {
    flex: 1,
    color: colors.textLight,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: 1.3,
  },
  sectionHeaderDarkValue: {
    color: colors.textLight,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: 1.3,
  },

  // Data row
  dataRow: {
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderBottom: `1 solid ${colors.borderColor}`,
  },

  // Field (label + value pair)
  fieldLabel: {
    color: colors.textDark,
    fontSize: 7.5,
    fontWeight: 'normal',
    lineHeight: 1.6,
  },
  fieldValue: {
    color: colors.textDark,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: 1.3,
  },
  fieldValueLight: {
    color: colors.textLight,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: 1.3,
  },

  // Resumo special value (dark background)
  resumoValueBox: {
    padding: 16,
    backgroundColor: colors.bgLayoutSecondary,
    flexDirection: 'column',
    gap: 8,
  },
  resumoValueLabel: {
    color: colors.textLight,
    fontSize: 7.5,
    fontWeight: 'normal',
    lineHeight: 1,
  },
  resumoValueText: {
    color: colors.textLight,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 1,
  },

  // Image placeholder
  imagePlaceholder: {
    backgroundColor: colors.bgBlack100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagePlaceholderText: {
    color: colors.textDark,
    fontSize: 9,
    fontWeight: 'normal',
    textAlign: 'center',
    lineHeight: 1.3,
  },

  // Footer
  footer: {
    height: 28,
    paddingHorizontal: 32,
    backgroundColor: colors.bgLayoutPrimary,
    borderTop: `1 solid ${colors.borderBg}`,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footerText: {
    color: colors.textDark,
    fontSize: 7.5,
    fontWeight: 'normal',
  },
  footerTextBold: {
    color: colors.textDark,
    fontSize: 7.5,
    fontWeight: 'bold',
  },

  // Link text
  linkText: {
    color: colors.textBrandPrimary,
    fontSize: 7,
    fontWeight: 'bold',
  },

  // Table styles (page 3)
  tableContainer: {
    marginTop: 0,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: colors.bgLayoutPrimary,
    borderBottom: `1 solid ${colors.borderColor}`,
  },
  tableHeaderCell: {
    fontSize: 7,
    fontWeight: 'bold',
    color: colors.textDark,
    textAlign: 'center',
    paddingVertical: 4,
    paddingHorizontal: 2,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: `1 solid ${colors.borderColor}`,
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottom: `1 solid ${colors.borderColor}`,
    backgroundColor: colors.bgLayoutPrimary,
  },
  tableCell: {
    fontSize: 7.5,
    color: colors.textDark,
    textAlign: 'center',
    paddingVertical: 4,
    paddingHorizontal: 2,
  },
  tableCellBold: {
    fontSize: 7.5,
    fontWeight: 'bold',
    color: colors.textDark,
    textAlign: 'center',
    paddingVertical: 4,
    paddingHorizontal: 2,
  },
  tableTotalRow: {
    flexDirection: 'row',
    borderBottom: `1 solid ${colors.borderColor}`,
    backgroundColor: colors.bgLayoutPrimary,
  },
  tableTotalCell: {
    fontSize: 8,
    fontWeight: 'bold',
    color: colors.textDark,
    textAlign: 'right',
    paddingVertical: 4,
    paddingHorizontal: 4,
  },

  // Homogenização box
  homoBox: {
    flexDirection: 'row',
    gap: 8,
  },
  homoField: {
    flex: 1,
    flexDirection: 'column',
    gap: 2,
  },

  // Valor boxes (garantia / leilão)
  valorGarantiaBox: {
    flex: 1,
    backgroundColor: '#10B981',
    borderRadius: 4,
    padding: 12,
    flexDirection: 'column',
    gap: 4,
  },
  valorLeilaoBox: {
    flex: 1,
    backgroundColor: colors.bgLayoutSecondary,
    borderRadius: 4,
    padding: 12,
    flexDirection: 'column',
    gap: 4,
  },
  valorBoxLabel: {
    color: colors.textLight,
    fontSize: 8,
    fontWeight: 'normal',
  },
  valorBoxValue: {
    color: colors.textLight,
    fontSize: 16,
    fontWeight: 'bold',
  },

  // Signature section
  signatureContainer: {
    alignItems: 'center',
    marginTop: 20,
    gap: 4,
  },
  signatureName: {
    fontSize: 10,
    fontWeight: 'bold',
    color: colors.textDark,
  },
  signatureInfo: {
    fontSize: 8,
    color: colors.textDark,
  },

  // Photo grid (page 4)
  photoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  photoCard: {
    width: '48%',
    border: `1 solid ${colors.borderColor}`,
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: 4,
  },
  photoCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colors.bgLayoutSecondary,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  photoCardHeaderText: {
    color: colors.textLight,
    fontSize: 7,
    fontWeight: 'bold',
  },
  photoCardHeaderInfo: {
    color: colors.textLight,
    fontSize: 7,
    fontWeight: 'normal',
  },
  photoCardImage: {
    width: '100%',
    height: 140,
    backgroundColor: colors.bgBlack100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  photoCardCaption: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderTop: `1 solid ${colors.borderColor}`,
  },
  photoCardCaptionText: {
    fontSize: 7,
    color: colors.textDark,
  },
});
